<template>
  <ul class="comment-list">
    <template v-for="(comment, index) in commentList">
      <li class="comment" :key="index">
        <van-image
          src="https://files.zhuokao360.com/mall/avatar.png"
          round
        ></van-image>
        <div class="comment-detail">
          <p>
            卓考网校学员<span class="comment-time" v-text="comment.time"></span>
          </p>
          <p class="comment-content" v-text="comment.content"></p>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
  import { COMMENTS } from './config';

  export default {
    name: 'DetailComment',
    data() {
      return {
        commentList: COMMENTS, // 评论列表
      };
    },
  };
</script>

<style lang="scss" scoped>
/* 评论列表 */
.comment-list {
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.comment {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.comment .van-image {
  width: 50px;
  height: 50px;
}

.comment-detail {
  flex: 1;
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}

.comment-time {
  margin-left: 10px;
}

.comment-content {
  margin-top: 10px;
  color: #333;
  line-height: 1.5;
}
</style>
